import { Injectable } from '@angular/core';
import { ListAuxiliaryDataRequestInterface, UpsertAuxiliaryDataRequestInterface } from '@vendasta/account-group'; // IAM SDK uses more annoying params
import { IAMService, ListAuxiliaryDataResponse } from '@vendasta/iamv2';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractAuxiliaryDataSchemaService } from './_abstract.service';

@Injectable({
  providedIn: 'root',
})
export class UserService implements AbstractAuxiliaryDataSchemaService {
  constructor(private readonly service: IAMService) {}

  listData(request: ListAuxiliaryDataRequestInterface): Observable<ListAuxiliaryDataResponse> {
    return this.service.listUserAuxiliaryData(request.auxiliaryDataObjectId, request.pagingOptions);
  }

  upsertData(request: UpsertAuxiliaryDataRequestInterface): Observable<null> {
    return this.service
      .upsertUserAuxiliaryData(request.auxiliaryDataObjectId, request.fieldDataUpsertOperations)
      .pipe(map(() => null));
  }
}
